import classes from './TrilliumUnsupportedOsPage.module.scss'
import React, { useContext } from 'react'
import Card from '../components/Card'
import useContentStack from '../hooks/useContentStack'
import { ContentStackTypes } from '../store/Constants'
import { ConfigContext } from '../store/ConfigContext'
import { ANALYTICS, useAnalyticsAPI } from '../analytics'
import { CmsDataFetchStatus } from '@jarvis/olex-content-management'
import LanguageSelector from '../components/LanguageSelector'

const TrilliumUnsupportedOsPage = () => {
  const { localization } = useContext(ConfigContext)

  const { trackScreenDisplay } = useAnalyticsAPI(
    ANALYTICS.SCREENS.UNSUPPORTED_OS
  )

  trackScreenDisplay()

  const { pageData, status } = useContentStack(
    ContentStackTypes.unsupported_os_trillium
  )

  if (status !== CmsDataFetchStatus.LOADED) return <div />

  return (
    <div className={classes.unsupportedOs}>
      <h3>{pageData.main_content.header_text}</h3>
      <Card className={classes.cardContainer} border={'outlined'}>
        <h4 data-testid="trillium-unsupported-header">
          {pageData.card_header}
        </h4>
        <div className={classes.deviceImageAndQrCodeSection}>
          <img src={pageData.main_content.device_image.url} />
          <div className={classes.qrCodeContentAndStoreLogos}>
            <div className={classes.qrCodeContent}>
              <img src={pageData.main_content.qr_code_image.url} />
              <article
                dangerouslySetInnerHTML={{
                  __html: pageData.main_content.body_text
                }}
              />
            </div>
            <div className={classes.storeLogos}>
              <img src={pageData.main_content.app_store_image.url} />
              <img src={pageData.main_content.google_play_image.url} />
            </div>
          </div>
        </div>
        <a href={pageData.main_content.get_help_on_hp_support.url}>
          {pageData.main_content.get_help_on_hp_support.title}
        </a>
      </Card>
      <LanguageSelector
        localization={localization}
        toggleButtonAnalytics={() => {}}
      />
    </div>
  )
}

export default TrilliumUnsupportedOsPage
